import { isAxiosError } from 'axios';
import { call, put, takeEvery, all } from 'redux-saga/effects';
import { api } from 'services';
import { responseErrors } from 'services/http/responseErrors';
import {
  dashboardInitState,
  getBalanceRequest,
  getBalanceSuccess,
  getPhoneCallsRequest,
  getPhoneCallsSuccess,
  getRegisteredUnregisteredRequest,
  getRegisteredUnregisteredSuccess,
  getTopChannelsRequest,
  getTopChannelsSuccess,
  getTotalChannelsByCategoryRequest,
  getTotalChannelsByCategorySuccess,
  getTotalGroupsByCategoryRequest,
  getTotalGroupsByCategorySuccess,
  getTotalUsersOnPlatformRequest,
  getTotalUsersOnPlatformSuccess,
} from './dashboard-reducer';

function* baseWorker(request: () => any, success: (payload: any) => any) {
  try {
    const response: { data: any } = yield call(request);
    const result = response?.data ?? response?.data ?? response;

    yield put(success(result));
  } catch (error) {
    if (isAxiosError(error)) {
      responseErrors(error);
    }
  } finally {
    yield put(dashboardInitState());
  }
}

export function* dashboardSaga() {
  yield all([
    takeEvery(getBalanceRequest.type, () =>
      baseWorker(api.dashboard.getBalance, getBalanceSuccess),
    ),
    takeEvery(getPhoneCallsRequest.type, () =>
      baseWorker(api.dashboard.getPhoneCalls, getPhoneCallsSuccess),
    ),
    takeEvery(getRegisteredUnregisteredRequest.type, () =>
      baseWorker(api.dashboard.getRegisteredUnregistered, getRegisteredUnregisteredSuccess),
    ),
    takeEvery(getTopChannelsRequest.type, () =>
      baseWorker(api.dashboard.getTopChannels, getTopChannelsSuccess),
    ),
    takeEvery(getTotalChannelsByCategoryRequest.type, () =>
      baseWorker(api.dashboard.getTotalChannelsByCategory, getTotalChannelsByCategorySuccess),
    ),
    takeEvery(getTotalGroupsByCategoryRequest.type, () =>
      baseWorker(api.dashboard.getTotalGroupsByCategory, getTotalGroupsByCategorySuccess),
    ),
    takeEvery(getTotalUsersOnPlatformRequest.type, () =>
      baseWorker(api.dashboard.getTotalUsersOnPlatform, getTotalUsersOnPlatformSuccess),
    ),
  ]);
}
